import { render, staticRenderFns } from "./ExportFtpModal.vue?vue&type=template&id=5ffe5584&scoped=true&"
import script from "./ExportFtpModal.vue?vue&type=script&lang=js&"
export * from "./ExportFtpModal.vue?vue&type=script&lang=js&"
import style0 from "./ExportFtpModal.vue?vue&type=style&index=0&id=5ffe5584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffe5584",
  null
  
)

export default component.exports